/* eslint-disable no-unused-vars */
import PersonalReviewer from "../../PersonalReviewer.vue";
import TotalOrderLogsPopup from "../TotalOrderLogsPopup.vue";
import Cookies from "js-cookie";
import CookieKeys from "@/model/constants/cookieKeys";
import RadialProgressBar from "vue-radial-progress";
import SwitchAccount from "../SwitchAccount.vue";
import CartOrder from "../CartOrder.vue";
import ProductListPage from "../ProductListPage";
import ProductVariantSelection from "../ProductVariantSelection";
import CartEntry from "../CartEntry";
import selfServiceStore from "@/store/selfService/selfService.js";
import {
  navigationQuestionForRedirect,
  getPosSettings
} from "@/api/AppSettings";
import {
  getCategoryAndProduct
} from "@/api/ProductCategory";
import {
  fetchUserWithCodes
} from "@/api/User";
import {
  fetchLastBillId,
  changePassword,
  updateEmail,
  mobileOrderCount
} from "@/api/SelfService";
import {
  getPaymentMethodList
} from "@/api/PaymentMethod";
import companyInfo from "../../../../model/constants/companyInfo";
import NewExpenseAddForSelfService from "../NewExpenseAddForSelfService.vue";
import TopOfTheDayScreen from "../TopOfTheDayScreen.vue";
import {
  isGranted
} from "@/utils/auth";
import PermissionTypes from "@/model/constants/permissionTypes";
import signalRService from "@/SignalRService";
import DayInterimScreen from "../DayInterimScreen.vue";
import {
  getIsDayOpening,
  getIsDayInterim,
  getBranchOpenClose,
  getRealTime
} from "@/api/DayOpen.js";
import DayCloseScreen from "../DayCloseScreen.vue";
import {
  installSelfServiceSessionTelemetry,
  ensureSelfServiceClientSessionId,
  logSelfServiceManualEvent,
  SelfServiceEventType
} from "@/utils/selfServiceSessionTelemetry";
import SafeCashEntry from "../SafeCashEntry.vue";
import {
  getNotifications,
  readNotifications
} from "@/api/UserWant";
import {
  GetAllDiscountReason
} from "@/api/DiscountReason.js";
export default {
  components: {
    ProductListPage,
    ProductVariantSelection,
    CartEntry,
    CartOrder,
    SwitchAccount,
    RadialProgressBar,
    TotalOrderLogsPopup,
    PersonalReviewer,
    NewExpenseAddForSelfService,
    TopOfTheDayScreen,
    DayInterimScreen,
    DayCloseScreen,
    SafeCashEntry,
  },
  data() {
    return {
      isSafeOperations: false,
      isUserOperations: false,
      isPersonalReviewerActive: false,
      profileActionPage: 0,
      newUserCodeObj: {},
      newUserEmailObj: {},
      isRequestActive: false,
      isAuth: false,
      isPosEnabled: false,
      isActiveChangePassword: false,
      toggleProfileActions: false,
      screenLock: true,
      cartEntry: null,
      productList: null,
      logo: companyInfo.logo,
      openClose: {},
      timerId: null,
      /** 45 sn hareketsizlikte otomatik PIN kilidi için. */
      idleLockTimerId: null,
      isTimerEffect: false,
      isEmailUpdate: false,
      newOrder: false,
      orderQuantity: 0,
      sidebarWidth: 'sidebar-reduced',
      audioPlayer: null,
      audioIsPlaying: false,
      lastPlayTime: 0,
      ignoreInitialSound: true,
      isMobileMenuOpen: false, // mobile menu açık mı değil mi kontrolü için eklendi
      isCartOrderOpen: false,
    };
  },
  computed: {
    isAddLoss() {
      return isGranted("discount_loss_create")
    },
    isOrderListActive() {
      const session = this.$store.getters["selfservice/getPaymentSessionState"];
      return !!(session && session.isActive);
    },
    isLoading: {
      get() {
        return this.$store.getters["selfservice/getIsLoading"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setIsLoading", val);
      },
    },
    isReset: {
      get() {
        return this.$store.getters["selfservice/getToIsReset"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setIsReset", val);
      },
    },
    isActiveTotalOrderLogs: {
      get() {
        return this.$refs.totalOrderLogsPopup.isActive;
      },
      set(val) {
        this.$refs.totalOrderLogsPopup.isActive = val;
      },
    },
    lossMode: {
      get() {
        return this.$store.getters["selfservice/getLossMode"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setLossMode", val);
      },
    },
    isCartOrderOpenGetter: {
      get() {
        return this.isCartOrderOpen;
      },
      set(val) {
        this.isCartOrderOpen = val;
      },
    },
    toUpdateEntry() {
      return this.$store.getters["selfservice/getToUpdateEntry"];
    },
    isProductVariantSelectionOpen: {
      get() {
        return this.$refs.variantSelection ?
          this.$refs.variantSelection.isProductVariantSelectionOpen :
          null;
      },
      set(val) {
        this.$refs.variantSelection.isProductVariantSelectionOpen = val;
      },
    },
    preSelectedProduct() {
      return this.$store.getters["selfservice/getPreSelectedProduct"];
    },
    selectedProduct() {
      return this.$store.getters["selfservice/getSelectedProduct"];
    },
    /** Ürün ağacı bileşeni yalnızca veri yokken veya sepet satırı düzenlenirken unmount olur. */
    productListPageShouldMount() {
      return this.productList != null && this.toUpdateEntry == null;
    },
    /** CartEntry / varyant açıkken grid gizlenir; v-show ile bileşen mounted kalır, kategori breadcrumb sıfırlanmaz. */
    productListPageVisible() {
      if (this.preSelectedProduct != null) {
        return false;
      }
      if (this.selectedProduct != null) {
        return false;
      }
      if (this.isProductVariantSelectionOpen === true) {
        return false;
      }
      return true;
    },
    isScreenLock: {
      get() {
        return this.$store.getters["selfservice/getScreenLock"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setScreenLock", val);
      },
    },
    isTopDay: {
      get() {
        return true;
      },
      set(val) {
        // this.$store.dispatch("selfservice/setScreenLock", val);
      },
    },
    activePersonal: {
      get() {
        const personal = this.$store.getters["selfservice/getActivePersonal"];
        if (personal == null) return null;
        return JSON.parse(JSON.stringify(personal));
      },
      set(val) {
        this.$store.dispatch("selfservice/setActivePersonal", val);
      },
    },
    isAdminActivePersonal() {
      const p = this.activePersonal;
      if (p == null || !p.role || !p.role.length) return false;
      return p.role.some(
        (x) => x.name == "admin" || x.name == "Şube Yatırımcısı"
      );
    },
    /** Oturum açan kullanıcıda `admin_access` (panel yöneticisi) var mı */
    isAppAdminUser() {
      return isGranted(PermissionTypes.Permissions_Administrator);
    },
  },
  watch: {
    profileActionPage(newVal, oldVal) {
      if (newVal < 0 || newVal > 1) this.profileActionPage = oldVal;
    },
    isActiveChangePassword(val) {
      this.newUserCodeObj = {};
    },
    preSelectedProduct: function (val) {
      if (val != null) {
        this.isProductVariantSelectionOpen = true;
      } else {
        this.isProductVariantSelectionOpen = false;
      }
    },
    activePersonal(val) {
      this.resetIdleLockTimer();
    },
  },
  methods: {
    // Get current order quantity
    async getOrderQuantity() {
      try {
        const response = await mobileOrderCount();
        this.orderQuantity = response;
        return response;
      } catch (error) {
        console.error("Error fetching order quantity:", error);
        return 0;
      }
    },

    // Check if there are new orders
    hasNewOrder() {
      return this.newOrder;
    },

    // Reset new order flag
    resetNewOrder() {
      this.newOrder = false;
    },

    // Refresh the order quantity
    async refreshOrderQuantity() {
      await this.getOrderQuantity();
      return this.orderQuantity;
    },

    // ProductListPage'i güncelle
    updateProductListPage() {
      if (this.$refs.productListPage) {
        console.log("ProductListPage sipariş sayısı güncelleniyor:", this.orderQuantity);
        this.$refs.productListPage.orderQuantity = this.orderQuantity;

        if (this.newOrder) {
          this.$refs.productListPage.newOrder = true;
          console.log("ProductListPage'de yeni sipariş işaretlendi");
        }
      } else {
        console.warn("ProductListPage henüz erişilebilir değil");
      }
    },

    openCustomerScreen() {
      const primaryScreenWidth = window.screen.width;
      const features = `fullscreen=yes,menubar=no,toolbar=no,location=no,status=no,left=${primaryScreenWidth},top=${window.screen.height},width=0,height=0`;
      window.open('/pages/customer-screen', 'Lütfen ekrana tıklayınız...', features);
    },

    // Mobile menu aç/kapa fonksiyonu (örnek)
    goToAdminDashboard() {
      this.$router.push({ name: "home" });
    },
    openCis() {
      const routeData = this.$router.resolve({ path: "/pages/cis" });
      window.open(routeData.href, "_blank");
    },

    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },

    // Mobile menu'yü kapatmak için fonksiyon (isteğe bağlı)
    closeMobileMenu() {
      this.isMobileMenuOpen = false;
    },

    // Ses çalma işlemini düzenli hale getir
    playOrderNotificationSound(forcePlay = false) {
      // Debug
      console.log("playOrderNotificationSound çağrıldı", {
        ignoreInitialSound: this.ignoreInitialSound,
        forcePlay,
        audioIsPlaying: this.audioIsPlaying,
        lastPlayTime: this.lastPlayTime,
        timeDiff: Date.now() - this.lastPlayTime
      });

      // Başlangıçta sesi engelle (uygulamanın açılışında gereksiz çalmaması için)
      if (this.ignoreInitialSound && !forcePlay) {
        console.log("Başlangıç sesi engellendi");
        this.ignoreInitialSound = false;
        return;
      }

      // Sesler arasında en az 5 saniye olsun (üst üste çalmayı önler)
      const MIN_TIME_BETWEEN_SOUNDS = 5000; // 5 saniye
      const now = Date.now();
      if (now - this.lastPlayTime < MIN_TIME_BETWEEN_SOUNDS && !forcePlay) {
        console.log(`Son çalmadan bu yana ${now - this.lastPlayTime}ms geçti - çok kısa, çalmıyor`);
        return;
      }

      if (this.audioPlayer) {
        // Çalıyor durumda ise önce durdur
        if (this.audioIsPlaying) {
          console.log("Ses zaten çalıyor, durdurulup sıfırlanıyor");
          this.audioPlayer.pause();
          this.audioPlayer.currentTime = 0;
        }

        // Ses dosyasını çal
        this.audioIsPlaying = true;
        this.lastPlayTime = now;
        console.log("Ses çalınmaya başlıyor");

        this.audioPlayer.play()
          .then(() => {
            console.log("Notification sound played successfully");
          })
          .catch(err => {
            console.error("Error playing sound:", err);
            this.audioIsPlaying = false;
          });

        // Ses bittiğinde bayrağı sıfırla
        this.audioPlayer.onended = () => {
          console.log("Ses çalma tamamlandı");
          this.audioIsPlaying = false;
        };
      } else {
        console.error("Audio player not initialized");
      }
    },

    getNotifications() {
      getNotifications().then(res => {
        console.log(res.data);
        if (res.data.length > 0) {
          this.$vs.notify({
            sticky: true,
            color: 'danger',
            position: 'top-right',
            title: 'İletişim sisteminde ' + res.data.length + ' adet yeni istek var.',
            text: 'Tıklayarak bu istekleri görüntüleyebilirsiniz.',
            clickClose: true,
            time: 999999,
            click: () => {
              console.log('click notification');
              readNotifications();
              this.$router.push('/pages/userwant');
            }
          })
        }
      })
    },
    getOpenClose: async function () {
      this.openClose = (await getBranchOpenClose()).data;
    },
    dayCloseClick() {
      this.$refs.dayclosescreenref.isOldClose = false;
      this.$refs.dayclosescreenref.isActive = true;
    },
    checkClosingTime: async function () {
      await this.getOpenClose();
      var remoteDate = await getRealTime();
      const currentTime = new Date(remoteDate.data);
      const targetTime = new Date();
      const currentTimeMinutes = currentTime.getHours() * 60 + currentTime.getMinutes();
      const targetTimeMinutes = parseInt(this.openClose.closeTime.split(":")[0]) * 60 + parseInt(this.openClose.closeTime.split(":")[1]);
      let timeDifference = targetTimeMinutes - currentTimeMinutes;
      let closeTime = new Date(this.openClose.openDate);
      let openTime = new Date(this.openClose.openDate);
      closeTime.setHours(parseInt(this.openClose.closeTime.split(":")[0]), parseInt(this.openClose.closeTime.split(":")[1]), 0);
      openTime.setHours(parseInt(this.openClose.openTime.split(":")[0]), parseInt(this.openClose.openTime.split(":")[1]), 0);
      console.log(currentTime);
      console.log(closeTime);
      console.log(openTime);
      if (openTime.getTime() > closeTime.getTime()) {
        closeTime.setDate(currentTime.getDate() + 1);
      }
      timeDifference = closeTime.getTime() - currentTime.getTime();
      if (timeDifference <= 600000) {
        this.isTimerEffect = true;
      } else {
        this.isTimerEffect = false;
      }
    },
    emitCloseReportSelfService(result) {
      if (result) {
        this.$refs.topofthedayscreenref.isActive = true;
      }
    },
    emitDisableSelfService(result) {
      if (result) {
        // document.getElementById('araRaporButton').disabled = true;
      }
    },
    saveExpense(payload) {
      this.$store.dispatch("expense/addExpense", payload).catch((error) => {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: error,
        });
      });
    },
    addNewExpense() {
      this.$refs.newExpenseAdd.isActive = true;
    },
    openKasaIslemleriFromMenu() {
      this.isSafeOperations = true;
      this.closeMobileMenu();
    },
    toggleUserOperations() {
      this.isUserOperations = !this.isUserOperations;
    },
    getAvatar(image) {
      if (image == "") return this.logo;
      else return this.$baseUrl + "/" + image;
    },
    resetProfileSelection() {
      this.toggleProfileActions = false;
      this.profileActionPage = 0;
    },
    toggleEmailUpdate() {
      this.isEmailUpdate = !this.isEmailUpdate;
      if (this.isEmailUpdate) {
        this.newUserEmailObj.email = this.activePersonal ? this.activePersonal.email : "";
      }
    },
    updateEmailMethod: async function () {
      console.log(this.newUserEmailObj.email);
      try {
        await updateEmail({
          id: this.activePersonal ? this.activePersonal.id : null,
          email: this.newUserEmailObj.email,
        }).then(res => {
          if (res && res.status == 200) {
            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Email güncellendi",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata",
              text: "Email güncellenemedi",
            });
          }
        });
      } catch (error) {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: error.response.data.Errors[0].Message,
        });
      }
    },
    changePassword: async function () {
      let check = await this.$validator.validateAll();
      if (!check) return;
      if (this.activePersonal.userCode != this.newUserCodeObj.oldCode) {
        this.$fire({
          title: "Hata !",
          text: "Eski Kod Aktif Kullanıcının Kodu ile Eşleşmiyor !",
          type: "error"
        })
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Eski Kod Aktif Kullanıcının Kodu ile Eşleşmiyor !",
        });
      } else {
        changePassword({
          userId: this.activePersonal.id,
          userCode: this.newUserCodeObj.newCode,
          oldUserCode: this.newUserCodeObj.oldCode,
        })
          .then((res) => {
            if (res && res.status == 200) {
              this.$vs.notify({
                color: "success",
                title: "Kod Başarıyla Değiştirildi !",
                text: "Yeni Kod Kullanıma Hazır.",
              });
              this.isActiveChangePassword = false;
              this.$store.dispatch(
                "selfservice/setActivePersonalUserCode",
                this.newUserCodeObj.newCode
              );
            }
          })
          .catch((x) => {
            const serverMessage = x && x.response && x.response.data && x.response.data.Errors && x.response.data.Errors[0]
              ? x.response.data.Errors[0].Message
              : "Kod Değiştirme Başarısız !";
            this.$fire({
              title: "Hata !",
              text: serverMessage,
              type: "error"
            });
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: serverMessage,
            });
          });
      }
    },
    doExit() {
      try {
        localStorage.removeItem('selfservice_carts');
        localStorage.removeItem('selfservice_payment_session');
        sessionStorage.removeItem('selfservice_locked');
      } catch (e) {
        console.error(e);
      }
      this.$router.push("/pages/login");
    },
    /** Kilit ikonu: PIN ekranını açar (manuel kilit ya da 45sn hareketsizlik). */
    requestLockPin(reason) {
      // Şablondan @click ile çağrıldığında ilk argüman DOM event'idir.
      const lockReason = typeof reason === "string" ? reason : "manual";
      const session = this.$store.getters["selfservice/getPaymentSessionState"];
      const isOrderActive = (session && session.isActive) || this.isOrderListActive;
      logSelfServiceManualEvent(SelfServiceEventType.ScreenLocked, {
        reason: lockReason,
        applied: !isOrderActive,
        skippedBecause: isOrderActive ? "ödeme ekranı açık" : undefined
      });
      if (!isOrderActive) {
        this.$store.dispatch("selfservice/setActivePersonal", null);
        this.$store.dispatch("selfservice/setScreenLock", true);
        this.$store.dispatch("selfservice/setPinEntryOpen", true);
        try {
          sessionStorage.setItem('selfservice_locked', '1');
        } catch (e) {
          console.error(e);
        }
      }
    },
    /** 45 sn hareketsizlik sayacını sıfırlar/başlatır. Aktif kullanıcı yoksa veya ekran zaten
     * kilitliyken gereksiz yere çalışmaz. Ödeme sürerken veya ödeme ekranı açıkken (kullanıcı etkileşimi olmasa da)
     * kilitlemeyi erteler, işlemi yarıda kesmesin diye. */
    resetIdleLockTimer() {
      if (this.idleLockTimerId) {
        clearTimeout(this.idleLockTimerId);
        this.idleLockTimerId = null;
      }
      const pinEntryOpen = this.$store.getters["selfservice/getPinEntryOpen"];
      if (!this.activePersonal || this.isScreenLock || pinEntryOpen) return;
      this.idleLockTimerId = setTimeout(() => {
        const session = this.$store.getters["selfservice/getPaymentSessionState"];
        if (session && (session.isActive || session.isPaymentStarted)) {
          this.resetIdleLockTimer();
          return;
        }
        this.requestLockPin("idle45s");
      }, 45000);
    },
    onIdleActivity() {
      this.resetIdleLockTimer();
    },
    onSelectProduct(val) {
      this.preSelectedProduct = val;
      this.isProductVariantSelectionOpen = true;
    },
    openCartOrder() {
      this.isCartOrderOpen = !this.isCartOrderOpen;
    },
    /** Pasta sorusu sonrası kategoriye gidilirken sepet paneli açıksa kapatır */
    closeCartIfOpen() {
      this.isCartOrderOpen = false;
    },
    productSelectionCompleted: function (val) {
      this.cartEntry = val;
      this.isProductVariantSelectionOpen = false;
      this.$store.dispatch("selfservice/setPreSelectedProduct", null);
    },
    closeProductSelection: function () {
      this.isProductVariantSelectionOpen = false;
    },
    fetchCategories: async function () {
      try {
        this.productList = await getCategoryAndProduct();
      } catch (e) {
        this.productList = null;
        this.$fire({
          title: "Hata !",
          text: e.message,
          type: "error"
        })
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: e.message,
        });
      }
    },
    /** @param autoAssign Terminal bu tarayıcı sekmesinde ilk kez açılıyorsa true: o zaman
     * gerçek giriş yapan kullanıcı PIN'siz aktif kullanıcı olarak atanır. Sayfa yenilemesi gibi
     * sonraki açılışlarda false gönderilir — kilidi PIN'siz atlatmasın diye otomatik atama yapılmaz. */
    fetchUsers: async function (autoAssign) {
      try {
        let response = await fetchUserWithCodes();
        let userInfo = JSON.parse(localStorage.getItem("userInfo"));
        var currentUser = userInfo ? response.find(x => x.id == userInfo.id || (x.email && x.email == userInfo.email) || (x.username && x.username == userInfo.username)) : null;
        this.$store.dispatch("selfservice/setPersonList", response);
        if (currentUser && autoAssign) {
          this.newUserEmailObj.email = currentUser.email;
          this.$store.dispatch("selfservice/setActivePersonal", currentUser);
        }
      } catch (e) {
        this.$store.dispatch("selfservice/setPersonList", null);
        this.$fire({
          title: "Hata !",
          text: e.message,
          type: "error"
        });
      }
    },
    fetchLastBillId: async function () {
      try {
        let response = await fetchLastBillId();
        this.$store.dispatch("selfservice/setLastBillId", response + 1);
      } catch (e) {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Son Fiş Numarası Alınamadı !"
        });
      }
    },
    getPaymentMethodList: async function () {
      try {
        let response = await getPaymentMethodList();
        if (response && response.length) {
          const creditCard = response.find(m => m.id == process.env.VUE_APP_CREDIT_PAYMENT_ID);
          if (creditCard) {
            response.forEach(m => m.selected = (m.id == process.env.VUE_APP_CREDIT_PAYMENT_ID));
          } else {
            response[0].selected = true;
          }
        }
        this.$store.dispatch("selfservice/setPaymentMethods", response);
      } catch (e) {
        this.$fire({
          title: "Hata !",
          text: e.message,
          type: "error"
        })
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: e.message,
        });
      }
    },
    getNavigationQuestionForSale: async function () {
      try {
        let response = await navigationQuestionForRedirect();
        this.$store.dispatch("selfservice/setNavigationQuestion", response);
      } catch (e) {
        this.$store.dispatch("selfservice/setNavigationQuestion", null);
        this.$fire({
          title: "Hata !",
          text: e.message,
          type: "error"
        })
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: e.message,
        });
      }
    },
    connectPos: async function (loadScreen) {
      this.isRequestActive = true;
      this.isLoading = loadScreen;
      await fetch(process.env.VUE_APP_POS_API + "pair", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      }).then((response) => response.json())
        .then((res) => {
          this.isRequestActive = false;
          this.isLoading = false;
          if (res.hasError == false || res.statusCode == 200) {
            this.$vs.notify({
              color: "success",
              title: "Pos Cihazına Bağlanıldı.",
              text: "",
            });
          } else if (res.message.includes("Cihaz Bağlantısı yapıldı")) {
            this.$vs.notify({
              color: "success",
              title: "Pos Cihaz Bağlantısı Yapıldı!",
              text: res.message,
            });
          } else {
            logSelfServiceManualEvent(SelfServiceEventType.PosConnectFailed, {
              trigger: loadScreen ? "manual" : "screenOpen",
              message: res && res.message
            });
            this.$fire({
              title: "Hata !",
              text: "Pos Cihaz Bağlantısı Yapılamadı !",
              type: "error"
            });
            this.$vs.notify({
              color: "danger",
              title: "Pos Cihaz Bağlantısı Yapılamadı !",
              text: res.message,
            });
          }
        })
        .catch((x) => {
          logSelfServiceManualEvent(SelfServiceEventType.PosConnectFailed, {
            trigger: loadScreen ? "manual" : "screenOpen",
            message: x && x.message ? x.message : String(x)
          });
          this.isRequestActive = false;
          this.isLoading = false;
          this.$fire({
            title: "Hata !",
            text: "Pos Cihaz Bağlantısı Yapılamadı !",
            type: "error"
          });
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Pos Cihaz Bağlantısı Yapılamadı !",
          });
        });
    },
    checkPosDevice: async function () {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"))
      if (!userInfo) {
        this.$router.push("/");
      }
      let branchId = await userInfo.branch.id
      let axiosResponse = await getPosSettings(branchId);
      localStorage.setItem("posSettings", JSON.stringify(axiosResponse.data));
      this.isPosEnabled = axiosResponse.data.enable;
    },
    getDiscountReasons: async function () {
      try {
        let response = await GetAllDiscountReason();
        if (response && response.status == 200) {
          this.$store.dispatch("selfservice/setDiscountReasons", response.data);
        } else {
          this.$fire({
            title: "Hata : " + response.status,
            text: "İndirim Sebepleri Yüklenemedi !",
            type: "error"
          });
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + response.status,
            text: "İndirim Sebepleri Yüklenemedi !"
          });
        }
      } catch (error) {
        this.$fire({
          title: "Hata",
          text: "İndirim Sebepleri Yüklenemedi!",
          type: "error"
        });
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "İndirim Sebepleri Yüklenirken Bağlantı Hatası!"
        });
      }
    },
  },
  created: async function () {
    // methods kısmındaki fonksiyonun çağrılması
    this.getNotifications();

    // İndirim sebeplerini başlangıçta bir kez yükleyelim
    this.getDiscountReasons();

    this.productList = null;
    await this.checkPosDevice();
    if (this.isPosEnabled) this.connectPos(false);
    this.fetchCategories();
    // Yenilemeden (F5) önce ekran kilitliyse (manuel kilit ya da 45sn hareketsizlik), bu durumu
    // hatırlayıp PIN'i tekrar isteriz. Kilitli DEĞİLKEN yenilemede ise normal akış işler
    // (gerçek login sahibine otomatik atama yapılır) — her yenilemede PIN sormayız.
    const wasLockedBeforeReload = sessionStorage.getItem('selfservice_locked') === '1';
    await this.fetchUsers(!wasLockedBeforeReload);
    if (wasLockedBeforeReload) {
      this.$store.dispatch("selfservice/setActivePersonal", null);
      this.$store.dispatch("selfservice/setScreenLock", true);
      this.$store.dispatch("selfservice/setPinEntryOpen", true);
    }
    this.fetchLastBillId();
    this.getPaymentMethodList();
    this.getNavigationQuestionForSale();
    let checkAuth = Cookies.get(CookieKeys.AUTH_KEY);
    checkAuth ? this.isAuth = true : this.$router.push('/pages/login');
    await this.getOpenClose();
    console.log(this.openClose);

    let isDayOpening = await getIsDayOpening();
    if (isDayOpening.data == 0) {
      this.$refs.topofthedayscreenref.isActive = true;
    }
    if (isDayOpening.data == 1) {
      this.$refs.dayclosescreenref.isOldClose = true;
      console.log(this.openClose);
      this.$refs.dayclosescreenref.lastOpenDate = this.openClose.lastOpenDate;
      this.$refs.dayclosescreenref.isActive = true;
    }
    let isDayInterim = await getIsDayInterim();
    if (isDayInterim.data) {
      //document.getElementById('araRaporButton').disabled = true;
    }
    this.timerId = setInterval(this.checkClosingTime, 300000);
    console.log("SignalR bağlantısı başlatılıyor...");
    await signalRService.initConnection();
    console.log("SignalR bağlantısı başarılı, olay dinleyicileri ayarlanıyor");

    // Bağlantı başarılıysa doğrudan burada dinleyicileri kaydet
    // Listen for new orders
    signalRService.on("SendOrder", (message) => {
      console.log("SelfService: Received order through SignalR:", message);
      console.log('ulaş test');

      var audio = new Audio(process.env.VUE_APP_ORDER_AUDIO);
      audio.play();

      // Önceki sipariş durumunu kontrol et
      const wasNewOrder = this.newOrder;
      this.newOrder = true;

      // ProductListPage bileşenine doğrudan erişimle yeni sipariş durumunu güncelle
      if (this.$refs.productListPage) {
        // ProductListPage'in verilerini güncelleyelim
        this.$refs.productListPage.newOrder = true;

        // Sipariş sayısını güncelleyelim
        this.refreshOrderQuantity().then(() => {
          if (this.$refs.productListPage) {
            this.$refs.productListPage.orderQuantity = this.orderQuantity;
          }
        });
      } else {
        console.error("ProductListPage bileşenine erişilemiyor");
      }

      // MobileOrder bileşeni açıksa sipariş listesini güncelle
      if (this.$refs.productListPage && this.$refs.productListPage.$refs.mobileOrder) {
        try {
          console.log("MobileOrder bileşenini güncelleme");
          this.$refs.productListPage.$refs.mobileOrder.getOrder();
        } catch (error) {
          console.error("MobileOrder bileşeni güncellenirken hata:", error);
        }
      }
    });

    // Listen for order quantity updates
    signalRService.on("OrderQuantityInBranch", (quantity) => {
      console.log("SelfService: Received order quantity update:", quantity);
      this.orderQuantity = quantity;

      // ProductListPage bileşenine doğrudan erişimle sipariş sayısını güncelle
      if (this.$refs.productListPage) {
        this.$refs.productListPage.orderQuantity = quantity;
      }
    });


    console.log("Sipariş sayısı alınıyor...");
    this.orderQuantity = await mobileOrderCount();
    console.log("Başlangıç sipariş sayısı:", this.orderQuantity);

    if (this.orderQuantity > 0) {
      console.log("Mevcut siparişler var, newOrder=true yapılıyor (ses çalınmayacak)");
      this.newOrder = true;

      // ProductListPage güncelleme denemesi (created'da erişilemeyebilir)
      this.$nextTick(() => {
        this.updateProductListPage();
      });
    }
  },

  // Sayfa oluşturulduktan sonra, DOM erişimi için
  mounted() {
    console.log("SelfService mount edildi, UI güncellemeleri yapılıyor");

    // Bir süre sonra tekrar deneyelim (DOM güncellemesinin tamamlanması için)
    setTimeout(() => {
      this.updateProductListPage();
    }, 200);

    // 45 sn hareketsizlikte otomatik PIN kilidi
    ["click", "keydown", "mousemove", "touchstart"].forEach((evt) => {
      window.addEventListener(evt, this.onIdleActivity, { passive: true });
    });
    this.resetIdleLockTimer();
  },

  beforeCreate: function () {
    // HMR GHOST CLEANUP: Tarayıcı yenilenmediğinde eski popup'ların DOM'da asılı kalmasını engelle!
    const ghostPopups = document.querySelectorAll('body > .vs-component.con-vs-popup');
    ghostPopups.forEach(popup => {
      popup.remove();
    });

    if (!selfServiceStore.isRegistered) {
      this.$store.registerModule("selfservice", selfServiceStore);
      selfServiceStore.isRegistered = true;
    }
    ensureSelfServiceClientSessionId(this.$store);
    installSelfServiceSessionTelemetry(this.$store);

    this.$store.subscribe((mutation, state) => {
      if (mutation.type && mutation.type.startsWith('selfservice/')) {
        const cartMutations = [
          'selfservice/ADD_TO_CART',
          'selfservice/UPDATE_TO_CART',
          'selfservice/REMOVE_ENTRY_FROM_CART',
          'selfservice/CREATE_NEW_CART',
          'selfservice/REMOVE_THE_CART',
          'selfservice/SET_CURRENT_CART',
          'selfservice/SET_CURRENT_CART_WITH_CAMPAIGN',
          'selfservice/SET_CURRENT_CART_CUSTOMER',
          'selfservice/SET_CURRENT_CART_PARTNER_QR'
        ];
        if (cartMutations.includes(mutation.type)) {
          try {
            localStorage.setItem('selfservice_carts', JSON.stringify(state.selfservice.carts));
          } catch (e) {
            console.error('Error saving carts to localStorage:', e);
          }
        }
      }
    });
  },
  beforeDestroy() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
    if (this.idleLockTimerId) {
      clearTimeout(this.idleLockTimerId);
    }
    ["click", "keydown", "mousemove", "touchstart"].forEach((evt) => {
      window.removeEventListener(evt, this.onIdleActivity);
    });

    // Remove event listeners when component is destroyed
    try {
      console.log("SignalR olay dinleyicileri kaldırılıyor");
      signalRService.off("SendOrder");
      signalRService.off("OrderQuantityInBranch");
      console.log("SignalR olay dinleyicileri başarıyla kaldırıldı");
    } catch (error) {
      console.error("SignalR olay dinleyicileri kaldırılırken hata:", error);
    }
  },
  provide() {
    return {
      refreshOrderQuantity: this.refreshOrderQuantity,
      getOrderQuantity: this.getOrderQuantity,
      hasNewOrder: this.hasNewOrder,
      resetNewOrder: this.resetNewOrder,
      closeCartIfOpen: this.closeCartIfOpen
    };
  }
};
